import React from "react";
import { Link } from "react-router-dom";
import MarketingNav from "@/components/MarketingNav";
import { Check } from "lucide-react";

const PLANS = [
  {
    id: "basic", name: "Basic", price: 10, tag: "For solo window cleaners",
    features: ["1 user", "Up to 100 customers", "Recurring jobs & calendar", "Daily route + map", "Stripe payments (card, Apple Pay, Google Pay)", "Branded invoices", "Email notifications"],
  },
  {
    id: "pro", name: "Pro", price: 20, featured: true, tag: "Most popular · small teams",
    features: ["Up to 3 users", "Unlimited customers", "Everything in Basic", "Staff assignment", "Priority support", "Custom branding"],
  },
  {
    id: "team", name: "Team", price: 35, tag: "Teams of 5 or more",
    features: ["5+ users", "Unlimited customers", "Everything in Pro", "Advanced admin controls", "Platform-level reporting"],
  },
];

export default function Pricing() {
  return (
    <div className="min-h-screen bg-background">
      <MarketingNav />
      <div className="max-w-6xl mx-auto px-6 py-20">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-primary">Pricing</div>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-bold">Fair pricing. 30-day free trial.</h1>
          <p className="mt-4 text-muted-foreground text-lg">No card up front. Pay monthly. Cancel anytime.</p>
        </div>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {PLANS.map((p) => (
            <div key={p.id} className={`rounded-2xl p-8 border ${p.featured ? "border-primary bg-primary/5 relative md:-translate-y-3" : "border-border bg-card"}`} data-testid={`plan-card-${p.id}`}>
              {p.featured && <div className="absolute -top-3 left-8 text-xs font-bold uppercase tracking-wider bg-primary text-primary-foreground px-3 py-1 rounded-full">Most popular</div>}
              <h3 className="font-display text-2xl font-bold">{p.name}</h3>
              <div className="text-sm text-muted-foreground mt-1">{p.tag}</div>
              <div className="mt-6 font-display text-5xl tracking-tighter font-bold">£{p.price}<span className="text-base text-muted-foreground font-medium">/mo</span></div>
              <ul className="mt-6 space-y-2.5 text-sm">
                {p.features.map((f) => <li key={f} className="flex items-start gap-2"><Check className="h-4 w-4 text-primary mt-0.5 shrink-0" />{f}</li>)}
              </ul>
              <Link to="/signup" className={`mt-8 inline-flex w-full items-center justify-center rounded-md px-4 py-2.5 font-medium transition ${p.featured ? "bg-primary text-primary-foreground hover:bg-primary/90" : "border border-border hover:bg-muted"}`} data-testid={`plan-cta-${p.id}`}>
                Start 30-day trial
              </Link>
            </div>
          ))}
        </div>
        <div className="mt-16 text-center text-sm text-muted-foreground max-w-xl mx-auto">
          All plans include a 30-day free trial — no credit card required. Upgrade, downgrade, or cancel anytime from your dashboard.
        </div>
      </div>
    </div>
  );
}
